import axios from 'axios';
import {getAuthToken} from '../../../utils/authStorage';
import {readMapFile} from './mapLayers';
import {readGeoTiff} from './geoTiff';
const auth=signal=>({signal,headers:{Authorization:`Bearer ${getAuthToken()}`}});
const base=id=>`/api/inspections/${id}/map-layers`;
export const layerId=id=>`saved-layer-${id}`;
export function sharedLayer(layer,record){return {...layer,id:layerId(record.id),savedId:record.id,name:record.name};}
export async function listSharedLayers(inspectionId,signal){return (await axios.get(base(inspectionId),auth(signal))).data;}
export async function removeSharedLayer(inspectionId,id){await axios.delete(`${base(inspectionId)}/${id}`,auth());}
export async function saveSharedLayer(inspectionId,file,bounds,onProgress,signal){
 const {data:upload}=await axios.post(base(inspectionId),{name:file.name,size:file.size,bounds:bounds||null},auth(signal));
 // Use a separate request: never attach the application bearer token to a storage URL.
 await new Promise((resolve,reject)=>{
  const xhr=new XMLHttpRequest();const abort=()=>xhr.abort();
  xhr.open('PUT',upload.uploadUrl);xhr.setRequestHeader('Content-Type',upload.contentType);
  xhr.upload.onprogress=e=>{if(e.lengthComputable)onProgress(Math.round(e.loaded/e.total*100));};
  const finish=fn=>{signal?.removeEventListener('abort',abort);fn();};
  xhr.onload=()=>finish(()=>xhr.status>=200&&xhr.status<300?resolve():reject(new Error('File upload failed. Check storage CORS settings and try again.')));
  xhr.onerror=()=>finish(()=>reject(new Error('File upload failed. Check your connection and storage CORS settings.')));
  xhr.onabort=()=>finish(()=>reject(new Error('Upload cancelled.')));
  if(signal?.aborted){reject(new Error('Upload cancelled.'));return;}
  signal?.addEventListener('abort',abort,{once:true});xhr.send(file);
 });
 return (await axios.post(`${base(inspectionId)}/${upload.id}/complete`,{},auth(signal))).data;
}
export async function loadSharedLayer(inspectionId,record,signal){
 let url=record.url,expires=Date.now()+50*60*1000,refreshing;
 const getUrl=async()=>{
  if(Date.now()<expires)return url;
  if(!refreshing)refreshing=axios.get(`${base(inspectionId)}/${record.id}`,auth(signal)).then(({data})=>{url=data.url;expires=Date.now()+50*60*1000;return url;}).finally(()=>{refreshing=null;});
  return refreshing;
 };
 let layer;
 if(/\.tiff?$/i.test(record.name))layer=await readGeoTiff({name:record.name,size:record.size,getUrl,signal});
 else {
  const response=await fetch(await getUrl(),{signal});if(!response.ok)throw new Error('Could not download the saved map layer.');
  const file=new File([await response.blob()],record.name);
  if(/\.(kmz|kml)$/i.test(record.name))layer=await readMapFile(file);
  else {
   if(!record.bounds)throw new Error('Saved image placement is missing.');
   const imageUrl=await new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve(reader.result);reader.onerror=reject;reader.readAsDataURL(file);});
   layer={name:record.name,data:{type:'FeatureCollection',features:[]},rasters:[{url:imageUrl,bounds:record.bounds}],opacity:.7,visible:true};
  }
 }
 return sharedLayer(layer,record);
}
